import React from 'react'
import useAxios from 'axios-hooks'
import { Table } from 'antd'
import { NoData } from 'components'
import { getAuthHeader } from 'utils/auth'
import { useProjects } from 'context/project-context'
import CreditsListColumns from 'views/UserManagement/Credits/CreditsListColumns'

const AccountCredits = () => {
  const project = useProjects()
  const [{ data: creditsResponse, loading: creditsLoading, error: creditsError }, getCurrentCredits] = useAxios(
    {
      url: `/account/credits`,
      method: 'GET',
      headers: getAuthHeader()
    },
    { manual: false }
  )
  return (
    <>
      {creditsResponse?.items &&
      !creditsLoading && (
        <Table
          pagination={{ hideOnSinglePage: true }}
          columns={CreditsListColumns(project)}
          dataSource={creditsResponse.items}
          loading={creditsLoading}
          size={'large'}
          locale={{
            emptyText: <NoData />
          }}
        />
      )}
    </>
  )
}

export default AccountCredits
